import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a table report view.
 * @extends JetView
 */
export default class tableReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        return {
            rows: [
                {
                    id: 'preloader', // Preloader ID
                    cols: [
                        {
                            view: 'datatable', // Data table view
                            id: 'datatable', // Data table ID
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                // Column definitions
                                {
                                    id: 'userId', // Column ID
                                    header: _('ID Usuario'), // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'userName', // Column ID
                                    header: _('Nombre Usuario'), // Column header
                                    width: 250, // Column width
                                    sort: 'string', // Sorting type
                                },
                                {
                                    id: 'rouletteId', // Column ID
                                    header: _('ID Ruleta'), // Column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'rouletteName', // Column ID
                                    header: _('Nombre Ruleta'), // Column header
                                    width: 250, // Column width
                                    sort: 'string', // Sorting type
                                },
                                {
                                    id: 'activationDate', // Column ID
                                    header: _('Fecha Activación'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'redemptionDate', // Column ID
                                    header: _('Fecha Redención'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'state', // Column ID
                                    header: _('Estado del Giro'), // Column header
                                    width: 100, // Column width
                                    sort: 'string', // Sorting type
                                },
                                {
                                    id: 'awardPresented',
                                    header: _('Premio Entregado'),
                                    width: 250,
                                    sort: 'string',
                                },
                                {
                                    id: 'typeAward', // Column ID
                                    header: _('Tipo de Premio'), // Column header
                                    width: 100, // Column width
                                    sort: 'string', // Sorting type
                                },
                                {
                                    id: 'awardDescription', // Column ID
                                    header: _('Detalle Premio'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'partner', // Column ID
                                    header: _('Partner'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'country', // Column ID
                                    header: _('País'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the data table instance
        var url = devConfig.geturlApi() + 'es/Report/GetSpinRoulette'; // API URL
        var filter = ''; // Filter string

        // Event listener for filtering user affiliates
        this.on(this.app, 'rouletteReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter query string

            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (object[i][0] == 'activationDate') {
                    var date = object[i][1].split(' - ');
                    string1 += '&dateFromActivation=' + date[0];
                    string1 += '&dateToActivation=' + date[1];
                } else if (object[i][0] == 'redemptionDate') {
                    var date = object[i][1].split(' - ');
                    string1 += '&dateFromRedemption=' + date[0];
                    string1 += '&dateToRedemption=' + date[1];
                } else if (object[i][0] == 'expirationDate') {
                    var date = object[i][1].split(' - ');
                    string1 += '&dateFromExpiration=' + date[0];
                    string1 += '&dateToExpiration=' + date[1];
                }

                else if (object[i][0] == 'userId') {
                    string1 += '&userId=' + object[i][1];
                } else if (object[i][0] == 'rouletteId') {
                    string1 += '&rouletteId=' + object[i][1];
                } else if (object[i][0] == 'rouletteName') {
                    string1 += '&rouletteName=' + encodeURIComponent(object[i][1]);
                } else if (object[i][0] == 'state') {
                    string1 += '&state=' + object[i][1];
                } else if (object[i][0] == 'typeAward') {
                    string1 += '&typeAward=' + object[i][1];
                } else if (object[i][0] == 'partnerId') {
                    string1 += '&partnerId=' + object[i][1];
                }else if (object[i][0] == 'countryId') {
                    string1 += '&countryId=' + object[i][1];
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });
    }
}

// FILE DOCUMENTED
